import { Routes, Route, Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "./context/AuthContext";
import { useTheme } from "./context/ThemeContext";
import HomeWithFilters from "./pages/HomeWithFilters";
import Contact from "./pages/Contact";
import WishlistPage from "./pages/WishlistPage";
import Dashboard from "./pages/Dashboard";
import { wishlistService } from "./services/wishlistService";
import Login from "./pages/Login";
import AccountSettings from "./pages/AccountSettings";
import AddProduct from "./pages/AddProduct";
import HamburgerMenu from "./components/HamburgerMenu";
import GoToTop from "./components/GoToTop";
import "./App.css";

export default function App() {
  const { darkMode, toggleDarkMode } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isContactPage = location.pathname === "/contact";

  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [sortBy, setSortBy] = useState("default");
  const [categories, setCategories] = useState(["All"]);

  const showFilters = true;

  const getUserId = () => {
    let userId = localStorage.getItem("anonymous_user_id");
    if (!userId) {
      userId = "user_" + Date.now();
      localStorage.setItem("anonymous_user_id", userId);
    }
    return userId;
  };

  const uid = getUserId();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchWishlistCount = async () => {
      try {
        const wishlist = await wishlistService.getWishlist(uid);
        console.log("App wishlist count:", wishlist.length, "items:", wishlist);
        setCount(wishlist.length);
      } catch (error) {
        console.error("Error fetching wishlist count:", error);
        setCount(0);
      }
    };

    fetchWishlistCount();

    const update = () => {
      console.log("Wishlist update event triggered in App");
      fetchWishlistCount();
    };

    window.addEventListener("wishlist-updated", update);
    return () => window.removeEventListener("wishlist-updated", update);
  }, []);

  return (
    <div className={`app ${darkMode ? "dark-mode" : ""}`}>
      <header className="header">
        <div className="header-inner">
          <div className="header-left">
            {showFilters ? (
              <HamburgerMenu
                search={search}
                setSearch={setSearch}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                sortBy={sortBy}
                setSortBy={setSortBy}
                categories={categories}
                wishlistCount={count}
              />
            ) : (
              <HamburgerMenu wishlistCount={count} />
            )}
          </div>

          <Link to="/" className="logo-link">
            <img src="/logo.png" alt="DoodleCart" className="logo-img" />
          </Link>

          <div className="header-right">
            {/* User email disabled for regular users */}
          </div>
        </div>
      </header>

      <main className="main">
        <Routes>
          <Route
            path="/"
            element={
              <HomeWithFilters
                search={search}
                setSearch={setSearch}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                sortBy={sortBy}
                setSortBy={setSortBy}
                categories={categories}
              />
            }
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          <Route path="/dashboard/:userId" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/account" element={<AccountSettings />} />
          <Route path="/add-product" element={<AddProduct />} />
        </Routes>

        <div className="rights">
          © {new Date().getFullYear()} Doodle Cart. All rights reserved
        </div>
      </main>

      <GoToTop />
    </div>
  );
}